module.exports = __webpack_public_path__ + "static/media/DFT-BNB.d5de94be.svg";